'use strict';
import React from 'react';
import * as T from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as FlipMoveConfig from '../../../config/style/FlipMoveListConfig';
import {LoadMoreComponent} from '../../../core-components/loading-icon/components/LoadMoreComponent';
import {StatusOverlayComponent} from '../../../core-components/loading-icon/components/StatusOverlayComponent';
import {MeasuredChatView} from '../../../core-components/measured-chat-view/MeasuredChatView';
import {ViewMode, ViewModePropType} from '../../../core-utilities/enums/ViewMode';
import {FeedItem} from '../FeedItem';


export function FeedListView(props) {
  // We technically don't need flip move here but it takes care of the need
  // for an inner wrapping element for MeasuredChatView's inner Measure component
  // We can get rid of it if we rewrite ChatView to put the inner Measure around the smoothScroll ref
  return (
    <div className={props.className}>
      <StatusOverlayComponent mode={props.mode} />
      <MeasuredChatView
        className={props.scrollClassName}
        flipped={false}
        scrollLoadThreshold={50}
        loadingSpinnerDelegate={<LoadMoreComponent mode={props.mode} />}
        onInfiniteLoad={props.onLoadMore}
      >
        <ReactCSSTransitionGroup
          transitionName={FlipMoveConfig.transitionName}
          transitionAppear={FlipMoveConfig.transitionAppear}
          transitionAppearTimeout={FlipMoveConfig.transitionAppearTimeout}
          transitionEnterTimeout={FlipMoveConfig.transitionEnterTimeout}
          transitionLeaveTimeout={FlipMoveConfig.transitionLeaveTimeout}
          className={props.transitionGroupClass}
        >
          {props.list.map(feedData => (
            <FeedItem
              key={feedData.id}
              className={props.itemClassName}
              entry={feedData}
              isOwnFeed={props.isOwnFeed}
              onClick={props.onSelectSingle}
            />
          ))}
        </ReactCSSTransitionGroup>
      </MeasuredChatView>
    </div>
  );
}

FeedListView.propTypes = {
  className: T.string,
  scrollClassName: T.string,
  transitionGroupClass: T.string,
  itemClassName: T.string,
  list: T.array,
  mode: ViewModePropType,

  onSelectSingle: T.func,
  onLoadMore: T.func,
};

FeedListView.defaultProps = {
  list: [],
  mode: ViewMode.LOADING,
  className: 'activity-feed-scroll-wrapper',
  scrollClassName: 'activity-feed-scroll-panel',
  transitionGroupClass: 'list',
};



// WEBPACK FOOTER //
// ./src/js/activity-feed/components/FeedList/FeedListView.js